<script setup>
import addressDIV from '@/components/checkout/address.vue'
import { getExchangeRateAPI } from '@/apis/wallet'
import LineList from '@/components/checkout/line.vue'
import axios from 'axios';
import PaymentMethods from '@/components/checkout/PaymentMethods.vue'
import { throttle } from "@/utils/throttle"; // 引入节流
import { getUnpaidOrderDetailAPI, getUserorOdersAPI, setPaymentOrderAPI, setPaymentOrderPostageAPI } from '@/apis/order'
import { addStoreOrderSteadyAPI } from '@/apis/user'
import { ElMessage } from 'element-plus'
import { useUserStore } from '@/stores/userStore'
import { useCartStore } from '@/stores/cartStore'
import { exchangeOrderRate } from '@/utils/index'
import routers from '@/router';
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
const { t } = useI18n();
const router = useRoute()
const cartStore = useCartStore()
const userStore = useUserStore()
// console.log(router.params.order_nos)
const order_status = ref(router.params.status)
const order_type = ref(router.params.type)
console.log(import.meta.env.VITE_APP_BASE_API)
const param = reactive({
    order_no_list: [],
    OrderDetail: {//获取支付订单信息
        // receive_address:'',//usd收款地址
        // order_nos:[],//订单号
        // stead_pay_detail:{//第三方支付信息

        // },
        // currency:'',
        // order_no:'',//订单号
        postage_price: null,//邮费
        goods_price: null,//商品价格
        total_price: null,//总支付价格 
        expire_time: null,//订单倒计时时间
        address_id: null,//地址id
        pay_intl_postage: false,//判断是否是支付邮费状态
    },
    transfer: {//转账支付
        bank_id: null,//银行id
        bank_name: '',//钱庄名称
    },
    paymentData: {
        currency: '',//币种
        // total_price:'',//订单支付金额
        order_nos: [],//订单号
        order_type: order_type,//1.商城平台,2.第三方
        pay_type: 1,//支付方式 1 积分支付 2 钱庄代付 3 usd支付 4 steadyPay支付  5.Palpay
        route_id: null,//线路id
        pay_info: {
            return_url: `${window.location.origin}/pay/`
            // return_url:`https://test-shop.51siteboost.com/pay/`
        },
        // address_id:null,//地址id
    },
    Postage: {
        route_id: null,//线路id
        postage: null,//线路价格
    }
})
/**
 * 第三方form表单提交参数
 */
const PaymentFromdata = reactive({
    form: {
        order_no: '',
        shopper_phone: '',//手机号
        first_name: '',//名
        last_name: '',//姓
        billing_postal_code: '',//邮箱
        billing_country: '',//国家
        billing_state: '',//市
        billing_city: '',//省份
        billing_address: '',//详细地址
        area_code: '',//手机区号
    },
    data: {
        merchant_id: '',
        account_id: '',
        currency: '',
        amount: null,
        order_no: '',
        notify_url: '',
        return_url: '',
        cancel_url: '',
        payment_method: '',
        shopper_id: '',
        shopper_email: '',
        encryption_data: '',
        action_url: '',
        shopper_phone: '',//手机号
        first_name: '',//名
        last_name: '',//姓
        billing_postal_code: '',//邮箱
        billing_country: '',//国家
        billing_state: '',//市
        billing_city: '',//省份
        billing_address: '',//详细地址
    },

})
//获取支付订单信息
const getUnpaidOrderDetail = async () => {
    console.log('订单', param.order_no_list)
    const Currencycheck = localStorage.getItem('CurrencyLANGUAGE')

    const res = await getUnpaidOrderDetailAPI({ order_nos: param.order_no_list, currency: Currencycheck })
    if (res.code == 0) {
        param.OrderDetail = { ...res.data }
        param.paymentData.order_nos = param.order_no_list;
        param.OrderDetail.expire_time = res.data.expire_time * 1000
        getExchangeRate(res.data.total_price)
        // param.paymentData.address_id=res.data.address_id
        // param.paymentData.total_price=res.data.total_price;
        // PaymentFromdata.data ={...res.data.stead_pay_detail}
    }
}
/**
 * 切换地址获取地址信息
 */
const getAddress = (data) => {
    console.log('切换地址获取的地址信息', data)

    param.paymentData.address_id = data.id
}
/**
 * 获取用户支付订单数
 */
const order_num = ref()
const getUserorOders = async () => {
    const res = await getUserorOdersAPI()
    if (res.code == 0) {
        order_num.value = res.data.order_num
    }
}
const sumitStoreOrderSteady = async () => {
    let code = PaymentFromdata.form.area_code.replace("+", "");
    let dataall = {
        // order_no:PaymentFromdata.form.order_no,
        shopper_phone: code + PaymentFromdata.form.shopper_phone + '',//手机号
        first_name: PaymentFromdata.form.first_name,//名
        last_name: PaymentFromdata.form.last_name,//姓
        billing_postal_code: PaymentFromdata.form.billing_postal_code,//邮箱
        billing_country: PaymentFromdata.form.billing_country,//国家
        billing_state: PaymentFromdata.form.billing_state,//市
        billing_city: PaymentFromdata.form.billing_city,//省份
        billing_address: PaymentFromdata.form.billing_address,//详细地址
    }
    PaymentFromdata.data.shopper_phone = dataall.shopper_phone;
    PaymentFromdata.data.first_name = dataall.first_name;
    PaymentFromdata.data.last_name = dataall.last_name;
    PaymentFromdata.data.billing_postal_code = dataall.billing_postal_code;
    PaymentFromdata.data.billing_country = dataall.billing_country;
    PaymentFromdata.data.billing_state = dataall.billing_state;
    PaymentFromdata.data.billing_city = dataall.billing_city;
    PaymentFromdata.data.billing_address = dataall.billing_address;

    // console.log(dataall)
    // const res = await addStoreOrderSteadyAPI(dataall)

    // if (res.code == 0) {
    nextTick(() => {
        console.log(PaymentFromdata.data)
        try {
            submitForm()
        } catch (error) {
            console.error('在 nextTick 回调中发生错误:', error);
        }
    });
    // }                           
}
const paymentForm = ref()
const submitForm = () => {
    if (paymentForm.value) {
        paymentForm.value.submit();
    }
}
const pricetotal = ref()
const ExchangeRate = ref()
/**
 * 获取汇率
 */
const getExchangeRate = async (data) => {
    const res = await getExchangeRateAPI()
    if (res.code == 0) {
        console.log(data)
        //   let  cnyData=res.data.CNY
        const Currency = userStore.exchangeRate.currency;
        ExchangeRate.value = res.data.CNY
        if (Currency != 'USD') {
            let dataRate = res.data[Currency];
            console.log(data)
            pricetotal.value = Number((data * dataRate['USD']).toFixed(3).slice(0, -1))
        } else {
            pricetotal.value = data
        }
        // pricetotal.value=Number((data* cnyData['USD']).toFixed(3).slice(0, -1))

    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const createPaymentOrder = async (url,formdata,token,returnurl) => {
   console.log('token',token)
    // 写死的请求数据
    // param.paymentData.pay_info.return_url = `${window.location.origin}/pay/${returnurl}`

    const requestData = {
        intent: formdata.intent,
        purchase_units: formdata.purchase_units,
        payment_source: 
        // formdata.payment_source,
        {
            paypal:{
                experience_context:{
                    return_url: `${window.location.origin}/pay/${returnurl}`,
                    cancal_url: `${window.location.origin}/Payment`,
                    
                }
            }
        }
    };
    // 'https://api-m.sandbox.paypal.com/v2/checkout/orders',

    try {
        console.log('发送请求数据:', requestData);

        const response = await axios.post(
            url,
            requestData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer '+token,
                    //  'Bearer '+userStore.userInfo.token, // 替换为你的访问令牌
                },
            }
        );

        console.log('收到响应:', response);

        if (response.status !== 200) {
            ElMessage({
                message: `HTTP error! status: ${response.status}`,
                type: 'warning',
            })
            return
        }

        const data = response.data;
        console.log('响应数据:', data);
        console.log('data.link:', data.link);

        // 找到支付链接
        const approvalUrl = data.links.find((link) => link.rel === 'payer-action')?.href;
        if (approvalUrl) {
            console.log('approvalUrl', approvalUrl);
            window.location.href = approvalUrl;
            // routers.replace({ path: approvalUrl })

        } else {
            ElMessage({
                message: '创建订单失败: ' + JSON.stringify(data),
                type: 'warning',
            })
        }
    } catch (error) {
        console.error('请求错误:', error);
    }
};
/**
 * 支付
 */
const paymentOrder = async () => {
    param.paymentData.currency = userStore.exchangeRate.currency;
    console.log(param.paymentData)
    if (param.paymentData.pay_type == 1) {//商城币支付
        console.log(pricetotal.value, userStore.userInfo?.balance)
        if (pricetotal.value > userStore.userInfo?.balance) {
            ElMessage({
                message: t('setup578'),
                type: 'warning',
            })
            return;
        }
    }

    if (param.paymentData.pay_type == 2) {//转账支付
        if (param.paymentData.pay_info.bank_name == '') {
            if (PaymentRef.value && isMobile.value) {
                PaymentRef.value.checkRadio(2) // 调用子组件暴露的方法
            }

            ElMessage({
                message: t('setup44'),
                type: 'warning',
            })
            return;
        }
    } else if (param.paymentData.pay_type == 4) {//steadyPay支付
        if (PaymentRef.value) {
            PaymentRef.value.paymentFormsubim() // 调用子组件暴露的方法
        }
        nextTick(() => {
            console.log('第三方支付', PaymentFromdata.data);
            console.log(PaymentFromdata.form)
        })
    } else if (param.paymentData.pay_type == 5 || param.paymentData.pay_type == 6 || param.paymentData.pay_type == 7) {
        let language = localStorage.getItem('language');
        if (language == 'zh-cn') {
            language = 'zn'
        }
        param.paymentData.pay_info.locale = language.toLowerCase()
    }
    console.log('支付', param.paymentData)
    const res = await setPaymentOrderAPI(param.paymentData)
    if (res.code == 0) {
        //支付成功判断支付方式跳转不同路由
        if (param.paymentData.pay_type == 3) {//ustd支付
            cartStore.usdData = res.data
            console.log('使用usd支付', res.data)
            routers.replace({ path: '/usdPayment' })

        } else if (param.paymentData.pay_type == 8) {//paypal
            // cartStore.usdData = res.data
            createPaymentOrder(res.data.pay_result.request_url,res.data.pay_result.form_data,res.data.pay_result.form_data.token,res.data.redirect)
            console.log('res.data', res.data)
            // routers.replace({ path: '/paypalPayment' })

        } else if (param.paymentData.pay_type == 4) {//steadyPay支付
            PaymentFromdata.data.account_id = res.data.pay_result.account_id;
            PaymentFromdata.data.action_url = res.data.pay_result.action_url;
            PaymentFromdata.data.amount = res.data.pay_result.amount;
            PaymentFromdata.data.cancel_url = res.data.pay_result.return_url;
            PaymentFromdata.data.currency = res.data.pay_result.currency;
            PaymentFromdata.data.encryption_data = res.data.pay_result.encryption_data;
            PaymentFromdata.data.merchant_id = res.data.pay_result.merchant_id;
            PaymentFromdata.data.notify_url = res.data.pay_result.notify_url;
            PaymentFromdata.data.order_no = res.data.pay_result.order_no;
            PaymentFromdata.data.payment_method = res.data.pay_result.payment_method;
            PaymentFromdata.data.return_url = res.data.pay_result.return_url;
            PaymentFromdata.data.shopper_email = res.data.pay_result.shopper_email;
            PaymentFromdata.data.shopper_id = res.data.pay_result.shopper_id;
            // 为按钮添加点击事件
            nextTick(() => {
                sumitStoreOrderSteady()
            });
        } else if (param.paymentData.pay_type == 5 || param.paymentData.pay_type == 6 || param.paymentData.pay_type == 7) {//代表oceanpayment支付

            paramOceanpay.OceanpayData = res.data.pay_result
            nextTick(() => {
                try {
                    oceanpaSubmitForm()
                } catch (error) {
                    console.error('在 nextTick 回调中发生错误:', error);
                }
            });
            // 2. 获取跳转链接
            // const approvalUrl = res.data.approval_url;

            // 3. 跳转到PayPal支付页面
            //window.location.href = approvalUrl; // 当前页跳转
            // 或打开新窗口
            // window.open(approvalUrl, '_blank');
        } else {

            ElMessage({ type: 'success', message: t('cart19') })
            // 更新购物车
            cartStore.updateNewList()
            routers.replace({ path: '/pay/' + res.data.redirect })

        }
    }
}
const handleSubmit = throttle(paymentOrder, 5000);
//支付线路
const setPostage = (data) => {
    console.log('线路值', data)
    param.Postage.route_id = data.route_id
    param.Postage.postage = data.postage
    param.OrderDetail.total_price = param.Postage.postage
}
const paramOceanpay = reactive({
    OceanpayData: {}
})
/**
 * 信用卡支付
 */
const oceanpayForm = ref()
const oceanpaSubmitForm = () => {
    if (oceanpayForm.value) {
        console.log('表单提交')
        oceanpayForm.value.submit();
    }
}
/**
 * 支付邮费
 */
const PayPostageu = async () => {

    if (param.paymentData.pay_type == 1) {
        // console.log( )
        let postage = Number((param.Postage.postage * ExchangeRate.value['USD']).toFixed(3).slice(0, -1))
        if (postage > userStore.userInfo?.balance) {
            console.log(postage, userStore.userInfo?.balance)
            ElMessage({
                message: t('setup578'),
                type: 'warning',
            })
            return;
        }
    }
    if (typeof param.paymentData.order_nos === "string") {
        console.log("这是一个字符串");
        param.paymentData.order_nos = [param.paymentData.order_nos];
    }
    param.paymentData.currency = userStore.exchangeRate.currency;
    param.paymentData.route_id = param.Postage.route_id
    param.paymentData.order_nos = param.paymentData.order_nos[0]
    param.paymentData.pay_info.return_url = `${window.location.origin}/pay/`
    console.log(param.paymentData)
    if (param.paymentData.pay_type == 2) {//转账支付
        if (param.paymentData.pay_info.bank_name == '') {
            console.log(111)
            ElMessage({
                message: t('setup44'),
                type: 'warning',
            })
            return;
        }
    } else if (param.paymentData.pay_type == 4) {//steadyPay支付
        if (PaymentRef.value) {
            PaymentRef.value.paymentFormsubim() // 调用子组件暴露的方法
        }
        nextTick(() => {
            console.log('第三方支付', PaymentFromdata.data);
            console.log(PaymentFromdata.form)
        })
    } else if (param.paymentData.pay_type == 5 || param.paymentData.pay_type == 6 || param.paymentData.pay_type == 7) {
        let language = localStorage.getItem('language');
        if (language == 'zh-cn') {
            language = 'zn'
        }
        param.paymentData.pay_info.locale = language.toLowerCase()
    }
    console.log('支付', param.paymentData)
    const res = await setPaymentOrderPostageAPI(param.paymentData)
    if (res.code == 0) {
        //支付成功判断支付方式跳转不同路由
        if (param.paymentData.pay_type == 3) {//ustd支付
            cartStore.usdData = res.data
            console.log('使用usd支付', res.data)
            routers.replace({ path: '/usdPayment' })

        } else if (param.paymentData.pay_type == 4) {//steadyPay支付
            PaymentFromdata.data.account_id = res.data.pay_result.account_id;
            PaymentFromdata.data.action_url = res.data.pay_result.action_url;
            PaymentFromdata.data.amount = res.data.pay_result.amount;
            PaymentFromdata.data.cancel_url = res.data.pay_result.cancel_url;
            PaymentFromdata.data.currency = res.data.pay_result.currency;
            PaymentFromdata.data.encryption_data = res.data.pay_result.encryption_data;
            PaymentFromdata.data.merchant_id = res.data.pay_result.merchant_id;
            PaymentFromdata.data.notify_url = res.data.pay_result.notify_url;
            PaymentFromdata.data.order_no = res.data.pay_result.order_no;
            PaymentFromdata.data.payment_method = res.data.pay_result.payment_method;
            PaymentFromdata.data.return_url = res.data.pay_result.return_url;
            PaymentFromdata.data.shopper_email = res.data.pay_result.shopper_email;
            PaymentFromdata.data.shopper_id = res.data.pay_result.shopper_id;
            // 为按钮添加点击事件
            nextTick(() => {
                sumitStoreOrderSteady()
            });
        } else if (param.paymentData.pay_type == 5 || param.paymentData.pay_type == 6 || param.paymentData.pay_type == 7) {//代表Palpay支付
            console.log(res.data)
            paramOceanpay.OceanpayData = res.data.pay_result
            nextTick(() => {
                try {
                    oceanpaSubmitForm()
                } catch (error) {
                    console.error('在 nextTick 回调中发生错误:', error);
                }
            });
            // 2. 获取跳转链接
            // const approvalUrl = res.data.approval_url;

            // 3. 跳转到PayPal支付页面
            //window.location.href = approvalUrl; // 当前页跳转
            // 或打开新窗口
            // window.open(approvalUrl, '_blank');
        }else if (param.paymentData.pay_type == 8) {//paypal
            createPaymentOrder(res.data.pay_result.request_url,res.data.pay_result.form_data,res.data.pay_result.form_data.token,res.data.redirect)

        } else {

            ElMessage({ type: 'success', message: t('cart19') })
            // 更新购物车
            cartStore.updateNewList()
            if (order_type.value == 1) {
                routers.replace({ path: '/pay/self' })
            } else {
                routers.replace({ path: '/pay/third' })
            }


        }
    }
}
const PayPostageubmit = throttle(PayPostageu, 5000)
/**
 * 获取支付方式，支付参数
 * @param data 
 */
const PaymentRef = ref();
const getPayment = (data) => {
    console.log('获取支付', data)
    param.paymentData.pay_type = data.pay_type
    if (data.pay_type == 2) {
        param.transfer.bank_id = data.checkCradItem?.id || null
        param.transfer.bank_name = data.checkCradItem?.bank_name || ""
        param.paymentData.pay_info.bank_id = data.checkCradItem?.id || null
        param.paymentData.pay_info.bank_name = data.checkCradItem?.bank_name || ""
    } else {
        if (data.pay_type == 4) {//第三方支付
            PaymentFromdata.form.order_no = param.order_no_list;
            PaymentFromdata.form.area_code = data.PaymentFromdata.area_code
            PaymentFromdata.form.shopper_phone = data.PaymentFromdata.shopper_phone;
            PaymentFromdata.form.first_name = data.PaymentFromdata.first_name;//名
            PaymentFromdata.form.last_name = data.PaymentFromdata.last_name;//姓
            PaymentFromdata.form.billing_postal_code = data.PaymentFromdata.billing_postal_code;//邮箱
            PaymentFromdata.form.billing_country = data.PaymentFromdata.billing_country;//国家
            PaymentFromdata.form.billing_state = data.PaymentFromdata.billing_state;//市
            PaymentFromdata.form.billing_city = data.PaymentFromdata.billing_city;//省份
            PaymentFromdata.form.billing_address = data.PaymentFromdata.billing_address;//详细地址

        }
        // param.paymentData.bank_id=null
        // param.paymentData.bank_name=""
    }

}

const isMobile = ref(false);
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('订单号', cartStore.order_no_list)
    param.order_no_list = [...cartStore.order_no_list];
    console.log(param.order_no_list)
    console.log(window.location.origin)
    nextTick(() => {
        getUserorOders();
        getUnpaidOrderDetail();

    })


})

</script>
<template>
    <div class="Payment">
        <div class="address contentflex" v-if="!order_status">
            <addressDIV v-if="param.OrderDetail?.address_id" :id="param.OrderDetail?.address_id"
                :orderNo="param.order_no_list[0]" :expired_at="param.OrderDetail?.expire_time"></addressDIV>
        </div>
        <div class="line contentflex" v-if="order_status && param.order_no_list[0]">
            <LineList :orderType="order_type" :orderNo="param.order_no_list[0]" @setPostage="setPostage"></LineList>
        </div>
        <div class="Methods contentflex" v-if="param.OrderDetail.total_price" style="margin-bottom: 20px;">
            <!-- {{ param.OrderDetail.total_price }} -->
            <PaymentMethods @getPayment="getPayment" ref="PaymentRef" :total="param.OrderDetail.total_price">
            </PaymentMethods>
        </div>

        <div class="DetailedAccount" v-if="isMobile == false">
            <div class="AccountSubmit" v-if="order_status">
                <div></div>
                <div style="display: flex;align-items: center;">
                    <div>{{ $t('setup486') }}：<span class="price">{{ exchangeOrderRate(param.Postage.postage,
                        userStore.exchangeRate.symbol, userStore.exchangeRate.currency,userStore.exchangeRate.rate)
                            }}</span>
                    </div>
                    <div class="submitbut" @click="PayPostageubmit">{{ $t('setup487') }}</div>
                </div>
            </div>
            <div class="AccountSubmit" v-else>
                <div>{{ $t('setup485') }}：
                    <span>{{ userStore.exchangeRate.symbol }}{{ param.OrderDetail.goods_price }}</span>
                </div>
                <div v-if="param.OrderDetail.postage_price != 0">{{ $t('setup474') }}：{{ userStore.exchangeRate.symbol }}{{
                    param.OrderDetail.postage_price}}</div>
                <div style="display: flex;align-items: center;">
                    <div>{{ $t('setup486') }}：<span class="price">
                            {{ userStore.exchangeRate.symbol }}{{ param.OrderDetail.total_price }}</span>
                    </div>
                    <div class="submitbut" @click="handleSubmit">{{ $t('setup487') }}</div>
                </div>
            </div>

        </div>
        <div class="Totalbottom" v-else>
            <div v-if="order_status" class="payableprice">
                <div class="Actualpayment">{{ $t('setup486') }}：
                    <span class="price" style="font-size: 18px;">{{ exchangeOrderRate(param.Postage.postage,
                        userStore.exchangeRate.symbol, userStore.exchangeRate.currency,
                        userStore.exchangeRate.rate)}}</span>
                </div>
                <div class="Payable" style="display: flex;">
                </div>
            </div>
            <div class="payableprice" v-else>
                <div class="Actualpayment">{{ $t('setup486') }}：
                    <span class="price" style="font-size: 18px;">
                        {{ userStore.exchangeRate.symbol }}{{ param.OrderDetail.total_price }}</span>
                </div>
                <div class="Payable" style="display: flex;">
                    <div style="margin-right: 8px;" v-if="param.OrderDetail.postage_price != 0">
                        {{ $t('setup474') }}：{{ userStore.exchangeRate.symbol }}{{ param.OrderDetail.postage_price }}</div>

                    {{ $t('setup457') }}：<span> {{ userStore.exchangeRate.symbol }}{{ param.OrderDetail.goods_price }}</span>
                </div>
            </div>
            <div v-if="order_status" class="submitbut" @click="PayPostageubmit">{{ $t('setup487') }}</div>
            <div v-else class="submitbut" @click="handleSubmit">{{ $t('setup487') }}</div>
        </div>
        <div style="visibility: hidden;height: 0;">
            <!-- 原生表单 -->
            <form ref="paymentForm" id="paymentForm" :action="PaymentFromdata.data.action_url" method="POST">
                <input type="hidden" name="merchant_id" :value="PaymentFromdata.data.merchant_id">
                <input type="hidden" name="account_id" :value="PaymentFromdata.data.account_id">
                <input type="hidden" name="currency" :value="PaymentFromdata.data.currency">
                <input type="hidden" name="amount" :value="PaymentFromdata.data.amount">
                <input type="hidden" name="order_no" :value="PaymentFromdata.data.order_no">
                <input type="hidden" name="notify_url" :value="PaymentFromdata.data.notify_url">
                <input type="hidden" name="return_url" :value="PaymentFromdata.data.return_url">
                <input type="hidden" name="cancel_url" :value="PaymentFromdata.data.cancel_url">
                <input type="hidden" name="payment_method" :value="PaymentFromdata.data.payment_method">
                <input type="hidden" name="shopper_id" :value="PaymentFromdata.data.shopper_id">
                <input type="hidden" name="shopper_email" :value="PaymentFromdata.data.shopper_email">
                <input type="hidden" name="encryption_data" :value="PaymentFromdata.data.encryption_data">

                <input type="hidden" name="shopper_phone" :value="PaymentFromdata.data.shopper_phone">
                <input type="hidden" name="first_name" :value="PaymentFromdata.data.first_name">
                <input type="hidden" name="last_name" :value="PaymentFromdata.data.last_name">
                <input type="hidden" name="billing_postal_code" :value="PaymentFromdata.data.billing_postal_code">
                <input type="hidden" name="billing_country" :value="PaymentFromdata.data.billing_country">
                <input type="hidden" name="billing_state" :value="PaymentFromdata.data.billing_state">
                <input type="hidden" name="billing_city" :value="PaymentFromdata.data.billing_city">
                <input type="hidden" name="billing_address" :value="PaymentFromdata.data.billing_address">
                <!-- 提交按钮 -->
                <button type="submit" id="submitButton">Submit</button>
            </form>
        </div>

        <!-- 隐藏的表单，用于自动提交 -->
        <form ref="oceanpayForm" :action="paramOceanpay.OceanpayData?.request_url" method="post" style="display: none;">
            <input v-for="(value, key) in paramOceanpay.OceanpayData?.form_data" :key="key" type="hidden" :name="key"
                :value="value" />
        </form>

    </div>
</template>
<style scoped lang="scss">
.Payment {
    height: auto;
    margin-top: 0px;
    background: #F0F2F3;
    padding: 20px 0px 0 0px;

    .address {

        padding-bottom: 20px;
    }

    .line {
        padding-bottom: 20px;
    }

    .Methods {}

    .DetailedAccount {
        margin-top: 32px;
        height: 100px;
        background: #FFFFFF;
        box-shadow: 0px -5px 8px 0px #F3F6F8;

        .AccountSubmit {
            height: 100px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 1200px;
            margin: 0 auto;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #0F0F0F;
            line-height: 19px;
            text-align: left;
            font-style: normal;

            .submitbut {
                margin-left: 46px;
                padding: 12px 76px;
                height: 46px;
                background: #FC3938;
                border-radius: 23px;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 21px;
                text-align: left;
                font-style: normal;
                text-transform: uppercase;
            }

            .price {
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 24px;
                color: #FC3938;
                line-height: 19px;
                text-align: left;
                font-style: normal;
            }
        }
    }
}

/* 响应式设计 */
@media (max-width: 768px) {
    .Payment {
        height: auto;
        margin-top: 88px;
        background: #f6f6f6;
        padding: 20px 15px 46px 15px;

        // min-height: calc(100% - 88px);

        .Totalbottom {
            height: 54px;
            background: #FFFFFF;
            padding: 4px 5px;
            z-index: 999;
            position: fixed;
            left: 0;
            bottom: 0;
            background: #fff;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            .submitbut {
                margin-left: 5px;
                background: #FC3938;
                border-radius: 20px;
                padding: 10px 34px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 20px;
                text-align: left;
                font-style: normal;
                display: flex;
                align-items: center;
            }

            .payableprice {
                display: flex;
                flex-direction: column;
                align-items: flex-end;

                .Actualpayment {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #FF4F00;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                }

                .Payable {
                    padding-top: 4px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 10px;
                    color: #999999;
                    line-height: 10px;
                    text-align: left;
                    font-style: normal;
                }
            }

        }

        .pricecolor {
            color: #FF4F00;
        }
    }
}
</style>